import ResultTables from "./components/table_results/ResultTables";

export const tabsOptions = (setFilterTestDataMode) => [{
  eventKey: 'graph',
  title: 'Gráficos',
  content: <div></div>,
  disabled: true
},{
  eventKey: 'tables',
  title: 'Tablas',
  content: <ResultTables setFilterTestDataMode={setFilterTestDataMode} />,
  disabled: false
}];